/*
 * =====================================================================================
 * DISCLAIMER:
 * =====================================================================================
 * This localization file is a community contribution and is not officially maintained
 * by Clerk. It has been provided by the community and may not be fully aligned
 * with the current or future states of the main application. Clerk does not guarantee
 * the accuracy, completeness, or timeliness of the translations in this file.
 * Use of this file is at your own risk and discretion.
 * =====================================================================================
 */

import type { LocalizationResource } from '@clerk/types';

export const bgBG: LocalizationResource = {
  locale: 'bg-BG',
  apiKeys: {
    action__add: undefined,
    action__search: undefined,
    createdAndExpirationStatus__expiresOn: undefined,
    createdAndExpirationStatus__never: undefined,
    detailsTitle__emptyRow: undefined,
    formButtonPrimary__add: undefined,
    formFieldCaption__expiration__expiresOn: undefined,
    formFieldCaption__expiration__never: undefined,
    formFieldOption__expiration__180d: undefined,
    formFieldOption__expiration__1d: undefined,
    formFieldOption__expiration__1y: undefined,
    formFieldOption__expiration__30d: undefined,
    formFieldOption__expiration__60d: undefined,
    formFieldOption__expiration__7d: undefined,
    formFieldOption__expiration__90d: undefined,
    formFieldOption__expiration__never: undefined,
    formHint: undefined,
    formTitle: undefined,
    lastUsed__days: undefined,
    lastUsed__hours: undefined,
    lastUsed__minutes: undefined,
    lastUsed__months: undefined,
    lastUsed__seconds: undefined,
    lastUsed__years: undefined,
    menuAction__revoke: undefined,
    revokeConfirmation: {
      confirmationText: undefined,
      formButtonPrimary__revoke: undefined,
      formHint: undefined,
      formTitle: undefined,
    },
  },
  backButton: 'Назад',
  badge__activePlan: undefined,
  badge__canceledEndsAt: undefined,
  badge__currentPlan: undefined,
  badge__default: 'По подразбиране',
  badge__endsAt: undefined,
  badge__expired: undefined,
  badge__otherImpersonatorDevice: 'Друго устройство за имитация',
  badge__primary: 'Основен',
  badge__renewsAt: undefined,
  badge__requiresAction: 'Изисква действие',
  badge__startsAt: undefined,
  badge__thisDevice: 'Това устройство',
  badge__unverified: 'Непотвърден',
  badge__upcomingPlan: undefined,
  badge__userDevice: 'Потребителско устройство',
  badge__you: 'Вие',
  commerce: {
    addPaymentMethod: undefined,
    alwaysFree: undefined,
    annually: undefined,
    availableFeatures: undefined,
    billedAnnually: undefined,
    billedMonthlyOnly: undefined,
    cancelSubscription: undefined,
    cancelSubscriptionAccessUntil: undefined,
    cancelSubscriptionNoCharge: undefined,
    cancelSubscriptionTitle: undefined,
    cannotSubscribeMonthly: undefined,
    checkout: {
      description__paymentSuccessful: undefined,
      description__subscriptionSuccessful: undefined,
      downgradeNotice: undefined,
      emailForm: {
        subtitle: undefined,
        title: undefined,
      },
      lineItems: {
        title__paymentMethod: undefined,
        title__statementId: undefined,
        title__subscriptionBegins: undefined,
        title__totalPaid: undefined,
      },
      pastDueNotice: undefined,
      perMonth: undefined,
      title: undefined,
      title__paymentSuccessful: undefined,
      title__subscriptionSuccessful: undefined,
    },
    credit: undefined,
    creditRemainder: undefined,
    defaultFreePlanActive: undefined,
    free: undefined,
    getStarted: undefined,
    keepSubscription: undefined,
    manage: undefined,
    manageSubscription: undefined,
    month: undefined,
    monthly: undefined,
    pastDue: undefined,
    pay: undefined,
    paymentMethods: undefined,
    paymentSource: {
      applePayDescription: {
        annual: undefined,
        monthly: undefined,
      },
      dev: {
        anyNumbers: undefined,
        cardNumber: undefined,
        cvcZip: undefined,
        developmentMode: undefined,
        expirationDate: undefined,
        testCardInfo: undefined,
      },
    },
    popular: undefined,
    pricingTable: {
      billingCycle: undefined,
      included: undefined,
    },
    reSubscribe: undefined,
    seeAllFeatures: undefined,
    subscribe: undefined,
    subtotal: undefined,
    switchPlan: undefined,
    switchToAnnual: undefined,
    switchToMonthly: undefined,
    totalDue: undefined,
    totalDueToday: undefined,
    viewFeatures: undefined,
    year: undefined,
  },
  createOrganization: {
    formButtonSubmit: 'Създаване на организация',
    invitePage: {
      formButtonReset: 'Пропусни',
    },
    title: 'Създаване на организация',
  },
  dates: {
    lastDay: "Вчера в {{ date | timeString('bg-BG') }}",
    next6Days: "{{ date | weekday('bg-BG','long') }} в {{ date | timeString('bg-BG') }}",
    nextDay: "Утре в {{ date | timeString('bg-BG') }}",
    numeric: "{{ date | numeric('bg-BG') }}",
    previous6Days: "Последно в {{ date | weekday('bg-BG','long') }} в {{ date | timeString('bg-BG') }}",
    sameDay: "Днес в {{ date | timeString('bg-BG') }}",
  },
  dividerText: 'или',
  footerActionLink__alternativePhoneCodeProvider: undefined,
  footerActionLink__useAnotherMethod: 'Използвайте друг метод',
  footerPageLink__help: 'Помощ',
  footerPageLink__privacy: 'Поверителност',
  footerPageLink__terms: 'Условия',
  formButtonPrimary: 'Продължи',
  formButtonPrimary__verify: 'Потвърди',
  formFieldAction__forgotPassword: 'Забравена парола?',
  formFieldError__matchingPasswords: 'Паролите съвпадат.',
  formFieldError__notMatchingPasswords: 'Паролите не съвпадат.',
  formFieldError__verificationLinkExpired: 'Линкът за потвърждение е изтекъл. Моля, заявете нов линк.',
  formFieldHintText__optional: 'По избор',
  formFieldHintText__slug: 'Slug е четим идентификатор, който трябва да бъде уникален. Често се използва в URL адреси.',
  formFieldInputPlaceholder__apiKeyDescription: undefined,
  formFieldInputPlaceholder__apiKeyExpirationDate: undefined,
  formFieldInputPlaceholder__apiKeyName: undefined,
  formFieldInputPlaceholder__backupCode: 'Въведете резервен код',
  formFieldInputPlaceholder__confirmDeletionUserAccount: 'Изтрий акаунта',
  formFieldInputPlaceholder__emailAddress: 'example@email.com',
  formFieldInputPlaceholder__emailAddress_username: 'example@email.com или име_потребител',
  formFieldInputPlaceholder__emailAddresses: 'example@email.com, example2@email.com',
  formFieldInputPlaceholder__firstName: undefined,
  formFieldInputPlaceholder__lastName: 'Вашето фамилно име',
  formFieldInputPlaceholder__organizationDomain: 'example.com',
  formFieldInputPlaceholder__organizationDomainEmailAddress: 'example@yourdomain.com',
  formFieldInputPlaceholder__organizationName: 'Име на организация',
  formFieldInputPlaceholder__organizationSlug: 'slug-организация',
  formFieldInputPlaceholder__password: 'Парола',
  formFieldInputPlaceholder__phoneNumber: '+359 123 456 789',
  formFieldInputPlaceholder__username: 'Име на потребител',
  formFieldLabel__apiKeyDescription: undefined,
  formFieldLabel__apiKeyExpiration: undefined,
  formFieldLabel__apiKeyName: undefined,
  formFieldLabel__automaticInvitations: 'Включи автоматични покани за този домейн',
  formFieldLabel__backupCode: 'Резервен код',
  formFieldLabel__confirmDeletion: 'Потвърждение',
  formFieldLabel__confirmPassword: 'Потвърдете паролата',
  formFieldLabel__currentPassword: 'Текуща парола',
  formFieldLabel__emailAddress: 'Имейл адрес',
  formFieldLabel__emailAddress_username: 'Имейл адрес или потребителско име',
  formFieldLabel__emailAddresses: 'Имейл адреси',
  formFieldLabel__firstName: 'Име',
  formFieldLabel__lastName: 'Фамилия',
  formFieldLabel__newPassword: 'Нова парола',
  formFieldLabel__organizationDomain: 'Домейн',
  formFieldLabel__organizationDomainDeletePending: 'Изтриване на изчакващи покани и предложения',
  formFieldLabel__organizationDomainEmailAddress: 'Имейл адрес за потвърждение',
  formFieldLabel__organizationDomainEmailAddressDescription:
    'Въведете имейл адрес под този домейн, за да получите код и да потвърдите домейна.',
  formFieldLabel__organizationName: 'Име',
  formFieldLabel__organizationSlug: 'Slug',
  formFieldLabel__passkeyName: undefined,
  formFieldLabel__password: 'Парола',
  formFieldLabel__phoneNumber: 'Телефонен номер',
  formFieldLabel__role: 'Роля',
  formFieldLabel__signOutOfOtherSessions: 'Изход от всички други устройства',
  formFieldLabel__username: 'Потребителско име',
  impersonationFab: {
    action__signOut: 'Изход',
    title: 'Влезли сте като {{identifier}}',
  },
  maintenanceMode: 'Режим на поддръжка',
  membershipRole__admin: 'Админ',
  membershipRole__basicMember: 'Член',
  membershipRole__guestMember: 'Гост',
  organizationList: {
    action__createOrganization: 'Създаване на организация',
    action__invitationAccept: 'Присъединяване',
    action__suggestionsAccept: 'Заявка за присъединяване',
    createOrganization: 'Създаване на организация',
    invitationAcceptedLabel: 'Присъединен',
    subtitle: 'за продължаване към {{applicationName}}',
    suggestionsAcceptedLabel: 'Чакащо одобрение',
    title: 'Изберете акаунт',
    titleWithoutPersonal: 'Изберете организация',
  },
  organizationProfile: {
    apiKeysPage: {
      title: undefined,
    },
    badge__automaticInvitation: 'Автоматични покани',
    badge__automaticSuggestion: 'Автоматични предложения',
    badge__manualInvitation: 'Няма автоматично включване',
    badge__unverified: 'Неверифициран',
    billingPage: {
      paymentHistorySection: {
        empty: undefined,
        notFound: undefined,
        tableHeader__amount: undefined,
        tableHeader__date: undefined,
        tableHeader__status: undefined,
      },
      paymentSourcesSection: {
        actionLabel__default: undefined,
        actionLabel__remove: undefined,
        add: undefined,
        addSubtitle: undefined,
        cancelButton: undefined,
        formButtonPrimary__add: undefined,
        formButtonPrimary__pay: undefined,
        payWithTestCardButton: undefined,
        removeResource: {
          messageLine1: undefined,
          messageLine2: undefined,
          successMessage: undefined,
          title: undefined,
        },
        title: undefined,
      },
      start: {
        headerTitle__payments: undefined,
        headerTitle__plans: undefined,
        headerTitle__statements: undefined,
        headerTitle__subscriptions: undefined,
      },
      statementsSection: {
        empty: undefined,
        itemCaption__paidForPlan: undefined,
        itemCaption__proratedCredit: undefined,
        itemCaption__subscribedAndPaidForPlan: undefined,
        notFound: undefined,
        tableHeader__amount: undefined,
        tableHeader__date: undefined,
        title: undefined,
        totalPaid: undefined,
      },
      subscriptionsListSection: {
        actionLabel__newSubscription: undefined,
        actionLabel__switchPlan: undefined,
        tableHeader__edit: undefined,
        tableHeader__plan: undefined,
        tableHeader__startDate: undefined,
        title: undefined,
      },
      subscriptionsSection: {
        actionLabel__default: undefined,
      },
      switchPlansSection: {
        title: undefined,
      },
      title: undefined,
    },
    createDomainPage: {
      subtitle:
        'Добавете домейн за верификация. Потребителите с имейл адреси на този домейн могат да се присъединят към организацията автоматично или да заявят да се присъединят.',
      title: 'Добавяне на домейн',
    },
    invitePage: {
      detailsTitle__inviteFailed:
        'Поканите не могат да бъдат изпратени. Вече има чакащи покани за следните имейл адреси: {{email_addresses}}.',
      formButtonPrimary__continue: 'Изпращане на покани',
      selectDropdown__role: 'Select role',
      subtitle: 'Въведете или поставете един или повече имейл адреси, разделени с интервали или запетая.',
      successMessage: 'Поканите бяха успешно изпратени',
      title: 'Покана за нови членове',
    },
    membersPage: {
      action__invite: 'Покани',
      action__search: undefined,
      activeMembersTab: {
        menuAction__remove: 'Премахване на член',
        tableHeader__actions: undefined,
        tableHeader__joined: 'Присъединил се',
        tableHeader__role: 'Роля',
        tableHeader__user: 'Потребител',
      },
      detailsTitle__emptyRow: 'Няма членове за показване',
      invitationsTab: {
        autoInvitations: {
          headerSubtitle:
            'Поканете потребители, свързващи имейл домейн с вашата организация. Всеки, който се регистрира със съответния имейл домейн, ще може да се присъедини към организацията по всяко време.',
          headerTitle: 'Автоматични покани',
          primaryButton: 'Управление на верифицираните домейни',
        },
        table__emptyRow: 'Няма покани за показване',
      },
      invitedMembersTab: {
        menuAction__revoke: 'Отмяна на поканата',
        tableHeader__invited: 'Поканени',
      },
      requestsTab: {
        autoSuggestions: {
          headerSubtitle:
            'Потребители, които се регистрират със съответния имейл домейн, ще видят предложение за заявка за присъединяване към вашата организация.',
          headerTitle: 'Автоматични предложения',
          primaryButton: 'Управление на верифицираните домейни',
        },
        menuAction__approve: 'Одобрение',
        menuAction__reject: 'Отхвърляне',
        tableHeader__requested: 'Заявен достъп',
        table__emptyRow: 'Няма заявки за показване',
      },
      start: {
        headerTitle__invitations: 'Покани',
        headerTitle__members: 'Членове',
        headerTitle__requests: 'Заявки',
      },
    },
    navbar: {
      apiKeys: undefined,
      billing: undefined,
      description: 'Управление на вашата организация.',
      general: 'Общи',
      members: 'Членове',
      title: 'Организация',
    },
    plansPage: {
      alerts: {
        noPermissionsToManageBilling: undefined,
      },
      title: undefined,
    },
    profilePage: {
      dangerSection: {
        deleteOrganization: {
          actionDescription: 'Въведете "{{organizationName}}" по-долу, за да продължите.',
          messageLine1: 'Сигурни ли сте, че искате да изтриете тази организация?',
          messageLine2: 'Това действие е перманентно и необратимо.',
          successMessage: 'Изтрихте организацията.',
          title: 'Изтриване на организацията',
        },
        leaveOrganization: {
          actionDescription: 'Въведете "{{organizationName}}" по-долу, за да продължите.',
          messageLine1:
            'Сигурни ли сте, че искате да напуснете тази организация? Ще загубите достъп до тази организация и нейните приложения.',
          messageLine2: 'Това действие е перманентно и необратимо.',
          successMessage: 'Излязохте от организацията.',
          title: 'Напускане на организацията',
        },
        title: 'Опасност',
      },
      domainSection: {
        menuAction__manage: 'Manage',
        menuAction__remove: 'Delete',
        menuAction__verify: 'Verify',
        primaryButton: 'Добавяне на домейн',
        subtitle:
          'Позволява на потребителите да се присъединяват към организацията автоматично или да заявят да се присъединят на база верифициран имейл домейн.',
        title: 'Верифицирани домейни',
      },
      successMessage: 'Организацията е актуализирана.',
      title: 'Актуализиране на профила',
    },
    removeDomainPage: {
      messageLine1: 'Имейл домейнът {{domain}} ще бъде премахнат.',
      messageLine2: 'Потребителите няма да могат да се присъединяват автоматично към организацията след това.',
      successMessage: '{{domain}} беше премахнат.',
      title: 'Премахване на домейн',
    },
    start: {
      headerTitle__general: 'General',
      headerTitle__members: 'Членове',
      profileSection: {
        primaryButton: undefined,
        title: 'Organization Profile',
        uploadAction__title: 'Logo',
      },
    },
    verifiedDomainPage: {
      dangerTab: {
        calloutInfoLabel: 'Премахването на този домейн ще засегне поканени потребители.',
        removeDomainActionLabel__remove: 'Премахване на домейн',
        removeDomainSubtitle: 'Премахнете този домейн от верифицираните си домейни',
        removeDomainTitle: 'Премахване на домейн',
      },
      enrollmentTab: {
        automaticInvitationOption__description:
          'Потребителите се поканват автоматично да се присъединят към организацията, когато се регистрират и могат да се присъединят по всяко време.',
        automaticInvitationOption__label: 'Автоматични покани',
        automaticSuggestionOption__description:
          'Потребителите получават предложение да заявят да се присъединят, но трябва да бъдат одобрени от администратор, преди да могат да се присъединят към организацията.',
        automaticSuggestionOption__label: 'Автоматични предложения',
        calloutInfoLabel: 'Промяната на режима на записване ще засегне само новите потребители.',
        calloutInvitationCountLabel: 'Чакащи покани, изпратени на потребители: {{count}}',
        calloutSuggestionCountLabel: 'Чакащи предложения, изпратени на потребители: {{count}}',
        manualInvitationOption__description: 'Потребителите могат да бъдат поканени само ръчно в организацията.',
        manualInvitationOption__label: 'Без автоматично записване',
        subtitle: 'Изберете как потребителите от този домейн могат да се присъединят към организацията.',
      },
      start: {
        headerTitle__danger: 'Опасност',
        headerTitle__enrollment: 'Опции за записване',
      },
      subtitle: 'Домейнът {{domain}} вече е верифициран. Продължете, като изберете режим на записване.',
      title: 'Актуализиране на {{domain}}',
    },
    verifyDomainPage: {
      formSubtitle: 'Въведете кода за верификация, изпратен на вашия имейл адрес',
      formTitle: 'Код за верификация',
      resendButton: 'Не сте получили код? Изпрати отново',
      subtitle: 'Домейнът {{domainName}} трябва да бъде верифициран чрез имейл.',
      subtitleVerificationCodeScreen:
        'Беше изпратен код за верификация на {{emailAddress}}. Въведете кода, за да продължите.',
      title: 'Верификация на домейн',
    },
  },
  organizationSwitcher: {
    action__createOrganization: 'Създаване на организация',
    action__invitationAccept: 'Присъединяване',
    action__manageOrganization: 'Управление',
    action__suggestionsAccept: 'Заявка за присъединяване',
    notSelected: 'Няма избрана организация',
    personalWorkspace: 'Личен акаунт',
    suggestionsAcceptedLabel: 'Чакащо одобрение',
  },
  paginationButton__next: 'Следващ',
  paginationButton__previous: 'Предишен',
  paginationRowText__displaying: 'Показване на',
  paginationRowText__of: 'от',
  reverification: {
    alternativeMethods: {
      actionLink: 'Get help',
      actionText: "Don't have one of these?",
      blockButton__backupCode: 'Use backup code',
      blockButton__emailCode: 'Send code to email',
      blockButton__passkey: undefined,
      blockButton__password: 'Login with password',
      blockButton__phoneCode: 'Send code to phone',
      blockButton__totp: 'Use authenticator app',
      getHelp: {
        blockButton__emailSupport: 'Contact support via email',
        content: 'If you need assistance, please contact support.',
        title: 'Need help?',
      },
      subtitle: 'Choose an alternative method to verify your identity.',
      title: 'Alternative methods',
    },
    backupCodeMfa: {
      subtitle: 'Enter the backup code sent to your email.',
      title: 'Backup code verification',
    },
    emailCode: {
      formTitle: 'Enter the verification code sent to your email address.',
      resendButton: "Didn't receive the code? Send it again.",
      subtitle: "We've sent a code to your email.",
      title: 'Email verification',
    },
    noAvailableMethods: {
      message: 'Unable to proceed. No available authentication methods.',
      subtitle: 'Something went wrong.',
      title: 'Authentication failed',
    },
    passkey: {
      blockButton__passkey: undefined,
      subtitle: undefined,
      title: undefined,
    },
    password: {
      actionLink: 'Use another method',
      subtitle: 'Enter your current password to continue using "{{applicationName}}"',
      title: 'Enter your password',
    },
    phoneCode: {
      formTitle: 'Enter the verification code sent to your phone number.',
      resendButton: "Didn't receive the code? Resend it.",
      subtitle: "We've sent a code to your phone.",
      title: 'Phone verification',
    },
    phoneCodeMfa: {
      formTitle: 'Enter the verification code sent to your phone number.',
      resendButton: "Didn't receive the code? Resend it.",
      subtitle: 'Verify using the code sent to your phone.',
      title: 'Phone number MFA',
    },
    totpMfa: {
      formTitle: 'Enter the verification code from your authenticator app.',
      subtitle: 'Use your authenticator app to get the code.',
      title: 'Authenticator App MFA',
    },
  },
  signIn: {
    accountSwitcher: {
      action__addAccount: 'Add account',
      action__signOutAll: 'Sign out of all accounts',
      subtitle: 'Select the account with which you wish to continue.',
      title: 'Choose an account',
    },
    alternativeMethods: {
      actionLink: 'Получете помощ',
      actionText: 'Нямате нито един от тях?',
      blockButton__backupCode: 'Използвай резервен код',
      blockButton__emailCode: 'Изпрати код по имейл до {{identifier}}',
      blockButton__emailLink: 'Изпрати линк по имейл до {{identifier}}',
      blockButton__passkey: undefined,
      blockButton__password: 'Влез с парола',
      blockButton__phoneCode: 'Изпрати SMS код до {{identifier}}',
      blockButton__totp: 'Използвай приложение за удостоверяване',
      getHelp: {
        blockButton__emailSupport: 'Имейл поддръжка',
        content:
          'Ако имате затруднения при влизане в профила си, изпратете ни имейл и ще работим с вас, за да възстановим достъпа възможно най-скоро.',
        title: 'Получи помощ',
      },
      subtitle: 'Имате проблеми? Можете да използвате някой от тези методи за влизане.',
      title: 'Използвайте друг метод',
    },
    alternativePhoneCodeProvider: {
      formTitle: undefined,
      resendButton: undefined,
      subtitle: undefined,
      title: undefined,
    },
    backupCodeMfa: {
      subtitle: 'Вашият резервен код е този, който сте получили при настройване на двустепенната аутентикация.',
      title: 'Въведете резервен код',
    },
    emailCode: {
      formTitle: 'Код за потвърждение',
      resendButton: 'Не сте получили код? Изпрати отново',
      subtitle: 'за да продължите към {{applicationName}}',
      title: 'Проверете вашия имейл',
    },
    emailLink: {
      clientMismatch: {
        subtitle: undefined,
        title: undefined,
      },
      expired: {
        subtitle: 'Върнете се в оригиналния таб, за да продължите.',
        title: 'Този линк за потвърждение е изтекъл',
      },
      failed: {
        subtitle: 'Върнете се в оригиналния таб, за да продължите.',
        title: 'Този линк за потвърждение е невалиден',
      },
      formSubtitle: 'Използвайте линкът за потвърждение, изпратен на вашия имейл адрес',
      formTitle: 'Линк за потвърждение',
      loading: {
        subtitle: 'Ще бъдете пренасочени скоро',
        title: 'Влизане...',
      },
      resendButton: 'Не сте получили линк? Изпрати отново',
      subtitle: 'за да продължите към {{applicationName}}',
      title: 'Проверете вашия имейл',
      unusedTab: {
        title: 'Можете да затворите този таб',
      },
      verified: {
        subtitle: 'Ще бъдете пренасочени скоро',
        title: 'Успешно влезли',
      },
      verifiedSwitchTab: {
        subtitle: 'Върнете се в оригиналния таб, за да продължите',
        subtitleNewTab: 'Върнете се в новоотворения таб, за да продължите',
        titleNewTab: 'Влезнали сте в друг таб',
      },
    },
    forgotPassword: {
      formTitle: 'Код за нулиране на парола',
      resendButton: 'Не сте получили код? Изпрати отново',
      subtitle: 'за да нулирате паролата си',
      subtitle_email: 'Първо, въведете кода, изпратен на вашия имейл',
      subtitle_phone: 'Първо, въведете кода, изпратен на вашия телефон',
      title: 'Нулиране на парола',
    },
    forgotPasswordAlternativeMethods: {
      blockButton__resetPassword: 'Нулирайте вашата парола',
      label__alternativeMethods: 'Или, влезте с друг метод',
      title: 'Забравена парола?',
    },
    noAvailableMethods: {
      message: 'Не може да се продължи с влизането. Няма наличен метод за удостоверяване.',
      subtitle: 'Възникна грешка',
      title: 'Неуспешно влизане',
    },
    passkey: {
      subtitle: undefined,
      title: undefined,
    },
    password: {
      actionLink: 'Използвайте друг метод',
      subtitle: 'Въведете паролата, свързана с вашия акаунт',
      title: 'Въведете вашата парола',
    },
    passwordPwned: {
      title: undefined,
    },
    phoneCode: {
      formTitle: 'Код за потвърждение',
      resendButton: 'Не сте получили код? Изпрати отново',
      subtitle: 'за да продължите към {{applicationName}}',
      title: 'Проверете вашия телефон',
    },
    phoneCodeMfa: {
      formTitle: 'Код за потвърждение',
      resendButton: 'Не сте получили код? Изпрати отново',
      subtitle: 'За да продължите, моля въведете кода за потвърждение, изпратен на вашия телефон',
      title: 'Проверете вашия телефон',
    },
    resetPassword: {
      formButtonPrimary: 'Нулирай паролата',
      requiredMessage: 'Вече съществува акаунт с непотвърден имейл адрес. Моля, нулирайте паролата си за сигурност.',
      successMessage: 'Паролата ви беше успешно променена. Влизане, моля изчакайте момент.',
      title: 'Задайте нова парола',
    },
    resetPasswordMfa: {
      detailsLabel: 'Трябва да потвърдим вашата самоличност, преди да нулираме паролата ви.',
    },
    start: {
      actionLink: 'Регистрирайте се',
      actionLink__join_waitlist: 'Присъединете се към листата за изчакване',
      actionLink__use_email: 'Използвайте имейл',
      actionLink__use_email_username: 'Използвайте имейл или потребителско име',
      actionLink__use_passkey: undefined,
      actionLink__use_phone: 'Използвайте телефон',
      actionLink__use_username: 'Използвайте потребителско име',
      actionText: 'Нямате акаунт?',
      actionText__join_waitlist: 'Все още нямате акаунт? Присъединете се към листата за изчакване.',
      alternativePhoneCodeProvider: {
        actionLink: undefined,
        label: undefined,
        subtitle: undefined,
        title: undefined,
      },
      subtitle: 'Добре дошли обратно! Моля, влезте, за да продължите',
      subtitleCombined: undefined,
      title: 'Влезте в {{applicationName}}',
      titleCombined: undefined,
    },
    totpMfa: {
      formTitle: 'Код за потвърждение',
      subtitle:
        'За да продължите, моля въведете кода за потвърждение, генериран от вашето приложение за удостоверяване',
      title: 'Двустепенна верификация',
    },
  },
  signInEnterPasswordTitle: 'Въведете вашата парола',
  signUp: {
    alternativePhoneCodeProvider: {
      resendButton: undefined,
      subtitle: undefined,
      title: undefined,
    },
    continue: {
      actionLink: 'Влезте',
      actionText: 'Вече имате акаунт?',
      subtitle: 'Моля, попълнете останалите данни, за да продължите.',
      title: 'Попълнете липсващите полета',
    },
    emailCode: {
      formSubtitle: 'Въведете кода за потвърждение, изпратен на вашия имейл адрес',
      formTitle: 'Код за потвърждение',
      resendButton: 'Не сте получили код? Изпрати отново',
      subtitle: 'Въведете кода за потвърждение, изпратен на вашия имейл',
      title: 'Потвърдете вашия имейл',
    },
    emailLink: {
      clientMismatch: {
        subtitle: undefined,
        title: undefined,
      },
      formSubtitle: 'Използвайте линка за потвърждение, изпратен на вашия имейл адрес',
      formTitle: 'Линк за потвърждение',
      loading: {
        title: 'Регистриране...',
      },
      resendButton: 'Не сте получили линк? Изпрати отново',
      subtitle: 'за да продължите към {{applicationName}}',
      title: 'Потвърдете вашия имейл',
      verified: {
        title: 'Успешно регистриран',
      },
      verifiedSwitchTab: {
        subtitle: 'Върнете се към новоотворения таб, за да продължите',
        subtitleNewTab: 'Върнете се към предходния таб, за да продължите',
        title: 'Успешно потвърден имейл',
      },
    },
    legalConsent: {
      checkbox: {
        label__onlyPrivacyPolicy: 'Съгласен съм само с политиката за конфиденциалност',
        label__onlyTermsOfService: 'Съгласен съм само с условията за ползване',
        label__termsOfServiceAndPrivacyPolicy:
          'Съгласен съм с {{ termsOfServiceLink || link("условията за ползване") }} и {{ privacyPolicyLink || link("политиката за конфиденциалност") }}',
      },
      continue: {
        subtitle: 'Продължете, за да завършите процеса',
        title: 'Прочетете и се съгласете с условията',
      },
    },
    phoneCode: {
      formSubtitle: 'Въведете кода за потвърждение, изпратен на вашия телефонен номер',
      formTitle: 'Код за потвърждение',
      resendButton: 'Не сте получили код? Изпрати отново',
      subtitle: 'Въведете кода за потвърждение, изпратен на вашия телефон',
      title: 'Потвърдете вашия телефон',
    },
    restrictedAccess: {
      actionLink: 'Получете помощ',
      actionText: 'Нямате нито един от тях?',
      blockButton__emailSupport: 'Свържете се с поддръжката по имейл',
      blockButton__joinWaitlist: 'Присъединете се към чакащия списък',
      subtitle: 'Възникна проблем с достъпа ви.',
      subtitleWaitlist: 'Можете да се присъедините към чакащия списък за бъдещи възможности.',
      title: 'Ограничен достъп',
    },
    start: {
      actionLink: 'Влезте',
      actionLink__use_email: 'Използвайте имейл',
      actionLink__use_phone: 'Използвайте телефон',
      actionText: 'Вече имате акаунт?',
      alternativePhoneCodeProvider: {
        actionLink: undefined,
        label: undefined,
        subtitle: undefined,
        title: undefined,
      },
      subtitle: 'Добре дошли! Моля, попълнете данните, за да започнете.',
      subtitleCombined: 'Добре дошли! Моля, попълнете данните, за да започнете.',
      title: 'Създайте своя акаунт',
      titleCombined: 'Създайте своя акаунт',
    },
  },
  socialButtonsBlockButton: 'Продължи с {{provider|titleize}}',
  socialButtonsBlockButtonManyInView: undefined,
  unstable__errors: {
    already_a_member_in_organization: 'Вие вече сте член на тази организация.',
    captcha_invalid: undefined,
    captcha_unavailable: undefined,
    form_code_incorrect: 'Невалиден код. Моля, опитайте отново.',
    form_identifier_exists__email_address: 'Този имейл адрес вече е регистриран.',
    form_identifier_exists__phone_number: 'Този телефонен номер вече е използван.',
    form_identifier_exists__username: 'Това потребителско име вече съществува.',
    form_identifier_not_found: 'Не можем да намерим този идентификатор.',
    form_param_format_invalid: undefined,
    form_param_format_invalid__email_address: 'Имейл адресът не е във валиден формат.',
    form_param_format_invalid__phone_number: 'Телефонният номер не е във валиден формат.',
    form_param_max_length_exceeded__first_name: 'Първото име не трябва да е по-дълго от 256 символа.',
    form_param_max_length_exceeded__last_name: 'Фамилията не трябва да е по-дълга от 256 символа.',
    form_param_max_length_exceeded__name: 'Името не трябва да надвишава 256 символа.',
    form_param_nil: undefined,
    form_param_value_invalid: undefined,
    form_password_incorrect: 'Невалидна парола. Моля, опитайте отново.',
    form_password_length_too_short: 'Паролата е твърде кратка. Моля, въведете поне 8 символа.',
    form_password_not_strong_enough:
      'Паролата трябва да съдържа поне една главна буква, една цифра и един специален символ.',
    form_password_pwned: 'Тази парола е компрометирана в изтекли данни. Моля, изберете друга.',
    form_password_pwned__sign_in: undefined,
    form_password_size_in_bytes_exceeded: 'Паролата ви е твърде дълга. Моля, съкратете я.',
    form_password_validation_failed: 'Невалидна парола.',
    form_username_invalid_character: 'Потребителското име съдържа невалидни символи.',
    form_username_invalid_length: 'Потребителското име трябва да бъде между 3 и 256 символа.',
    identification_deletion_failed: 'Не можете да изтриете последната си идентификация.',
    not_allowed_access:
      'Имейл адресът или телефонният номер не са разрешени за регистрация. Това може да се дължи на използването на „+“, „=“, „#“ или „.“ във вашия имейл адрес, като използвате домейн, свързан с временна имейл услуга, или сте изрично блокирани. Ако смятате, че това е грешка, моля, свържете се с поддръжката.',
    organization_domain_blocked: 'Доменът на организацията е блокиран.',
    organization_domain_common: 'Доменът на организацията е твърде общ.',
    organization_domain_exists_for_enterprise_connection: undefined,
    organization_membership_quota_exceeded: 'Квотата за членове на организацията е изчерпана.',
    organization_minimum_permissions_needed: 'Трябва да имате минимални разрешения за достъп.',
    passkey_already_exists: undefined,
    passkey_not_supported: undefined,
    passkey_pa_not_supported: undefined,
    passkey_registration_cancelled: undefined,
    passkey_retrieval_cancelled: undefined,
    passwordComplexity: {
      maximumLength: 'по-малко от {{length}} символа',
      minimumLength: '{{length}} или повече символа',
      requireLowercase: 'малка буква',
      requireNumbers: 'число',
      requireSpecialCharacter: 'специален символ',
      requireUppercase: 'главна буква',
      sentencePrefix: 'Вашата парола трябва да съдържа',
    },
    phone_number_exists: 'Този телефонен номер е зает. Моля, опитайте с друг.',
    session_exists: 'Вече сте влезнали.',
    web3_missing_identifier: undefined,
    zxcvbn: {
      couldBeStronger: 'Вашата парола работи, но може да бъде по-сигурна. Опитайте да добавите повече символи.',
      goodPassword: 'Вашата парола отговаря на всички необходими изисквания.',
      notEnough: 'Вашата парола не е достатъчно сигурна.',
      suggestions: {
        allUppercase: 'Направете главни някои, но не всички букви.',
        anotherWord: 'Добавете още думи, които са по-малко обичайни.',
        associatedYears: 'Избягвайте години, свързани с вас.',
        capitalization: 'Напревете главни повече от първата буква.',
        dates: 'Избягвайте дати и години, свързани с вас.',
        l33t: 'Избягвайте предвидими замествания на букви като "@" за "a".',
        longerKeyboardPattern: 'Използвайте по-дълги клавишни шаблони и променяйте посоката на набиране няколко пъти.',
        noNeed: 'Можете да създадете сигурни пароли и без да използвате символи, числа или главни букви.',
        pwned: 'Ако използвате тази парола на друго място, трябва да я промените.',
        recentYears: 'Избягвайте скорошни години.',
        repeated: 'Избягвайте повтарящи се думи и символи.',
        reverseWords: 'Избягвайте обърнати написания на обичайни думи.',
        sequences: 'Избягвайте обичайни последователности от символи.',
        useWords: 'Използвайте няколко думи, но избягвайте обичайни фрази.',
      },
      warnings: {
        common: 'Това е често използвана парола.',
        commonNames: 'Обичайни имена и фамилии са лесни за отгадване.',
        dates: 'Датите са лесни за отгадване.',
        extendedRepeat: 'Повтарящи се символни шаблони като "abcabcabc" са лесни за отгадване.',
        keyPattern: 'Кратки клавишни шаблони са лесни за отгадване.',
        namesByThemselves: 'Единични имена или фамилии са лесни за отгадване.',
        pwned: 'Вашата парола е била компроментирана от изтекли данни в Интернет.',
        recentYears: 'Скорошни години са лесни за отгадване.',
        sequences: 'Обичайни символни последователности като "abc" са лесни за отгадване.',
        similarToCommon: 'Това е подобно на често използвана парола.',
        simpleRepeat: 'Повтарящи се символи като "aaa" са лесни за отгадване.',
        straightRow: 'Редове от клавиши на клавиатурата са лесни за отгадване.',
        topHundred: 'Това е често използвана парола.',
        topTen: 'Това е често използвана парола.',
        userInputs: 'Не трябва да има лични или свързани със страницата данни.',
        wordByItself: 'Единични думи са лесни за отгадване.',
      },
    },
  },
  userButton: {
    action__addAccount: 'Добавяне на акаунт',
    action__manageAccount: 'Управление на акаунта',
    action__signOut: 'Изход',
    action__signOutAll: 'Изход от всички акаунти',
  },
  userProfile: {
    apiKeysPage: {
      title: undefined,
    },
    backupCodePage: {
      actionLabel__copied: 'Копирано!',
      actionLabel__copy: 'Копиране на всички',
      actionLabel__download: 'Изтегляне на .txt',
      actionLabel__print: 'Отпечатване',
      infoText1: 'Резервните кодове ще бъдат активирани за този акаунт.',
      infoText2:
        'Дръжте резервните кодове в тайна и ги съхранявайте сигурно. Можете да генерирате нови резервни кодове, ако подозирате, че те са били компрометирани.',
      subtitle__codelist: 'Запазете ги сигурно и ги държете в тайна.',
      successMessage:
        'Резервните кодове са активирани. Можете да използвате един от тях, за да влезете в акаунта си, ако загубите достъпа до устройството си за удостоверяване. Всеки код може да се използва само веднъж.',
      successSubtitle:
        'Можете да използвате един от тях, за да влезете в акаунта си, ако загубите достъпа до устройството си за удостоверяване.',
      title: 'Добавяне на резервен код за потвърждение',
      title__codelist: 'Резервни кодове',
    },
    billingPage: {
      paymentHistorySection: {
        empty: undefined,
        notFound: undefined,
        tableHeader__amount: undefined,
        tableHeader__date: undefined,
        tableHeader__status: undefined,
      },
      paymentSourcesSection: {
        actionLabel__default: undefined,
        actionLabel__remove: undefined,
        add: undefined,
        addSubtitle: undefined,
        cancelButton: undefined,
        formButtonPrimary__add: undefined,
        formButtonPrimary__pay: undefined,
        payWithTestCardButton: undefined,
        removeResource: {
          messageLine1: undefined,
          messageLine2: undefined,
          successMessage: undefined,
          title: undefined,
        },
        title: undefined,
      },
      start: {
        headerTitle__payments: undefined,
        headerTitle__plans: undefined,
        headerTitle__statements: undefined,
        headerTitle__subscriptions: undefined,
      },
      statementsSection: {
        empty: undefined,
        itemCaption__paidForPlan: undefined,
        itemCaption__proratedCredit: undefined,
        itemCaption__subscribedAndPaidForPlan: undefined,
        notFound: undefined,
        tableHeader__amount: undefined,
        tableHeader__date: undefined,
        title: undefined,
        totalPaid: undefined,
      },
      subscriptionsListSection: {
        actionLabel__newSubscription: undefined,
        actionLabel__switchPlan: undefined,
        tableHeader__edit: undefined,
        tableHeader__plan: undefined,
        tableHeader__startDate: undefined,
        title: undefined,
      },
      subscriptionsSection: {
        actionLabel__default: undefined,
      },
      switchPlansSection: {
        title: undefined,
      },
      title: undefined,
    },
    connectedAccountPage: {
      formHint: 'Изберете доставчик, за да свържете вашия профил.',
      formHint__noAccounts: 'Няма налични външни акаунт доставчици.',
      removeResource: {
        messageLine1: '{{identifier}} ще бъде премахнат от този профил.',
        messageLine2:
          'Няма да можете да използвате този свързан акаунт, и всякакви зависими функции няма да работят повече.',
        successMessage: '{{connectedAccount}} беше премахнат от вашия профил.',
        title: 'Премахни свързан акаунт',
      },
      socialButtonsBlockButton: 'Свържи акаунт {{provider|titleize}}',
      successMessage: 'Доставчикът беше добавен към вашия профил',
      title: 'Добави свързан акаунт',
    },
    deletePage: {
      actionDescription: 'Напишете "Изтриване на акаунта" по-долу, за да продължите.',
      confirm: 'Изтриване на акаунта',
      messageLine1: 'Сигурни ли сте, че искате да изтриете акаунта си?',
      messageLine2: 'Това действие е перманентно и необратимо.',
      title: 'Изтриване на акаунта',
    },
    emailAddressPage: {
      emailCode: {
        formHint: 'На този имейл адрес ще бъде изпратен имейл с код за потвърждение.',
        formSubtitle: 'Въведете кода за потвърждение, изпратен на {{identifier}}',
        formTitle: 'Код за потвърждение',
        resendButton: 'Не сте получили код? Изпрати отново',
        successMessage: 'Имейлът {{identifier}} беше добавен към вашия профил.',
      },
      emailLink: {
        formHint: 'На този имейл адрес ще бъде изпратен имейл с линк за потвърждение.',
        formSubtitle: 'Кликнете върху линка за потвърждение в имейла, изпратен на {{identifier}}',
        formTitle: 'Линк за потвърждение',
        resendButton: 'Не сте получили линк? Изпрати отново',
        successMessage: 'Имейлът {{identifier}} беше добавен към вашия профил.',
      },
      enterpriseSSOLink: {
        formButton: undefined,
        formSubtitle: undefined,
      },
      formHint: undefined,
      removeResource: {
        messageLine1: '{{identifier}} ще бъде премахнат от този профил.',
        messageLine2: 'Няма да можете да влезете в профила си, използвайки този имейл адрес.',
        successMessage: '{{emailAddress}} беше премахнат от вашия профил.',
        title: 'Премахни имейл адрес',
      },
      title: 'Добави имейл адрес',
      verifyTitle: 'Verify email address',
    },
    formButtonPrimary__add: 'Add',
    formButtonPrimary__continue: 'Продължи',
    formButtonPrimary__finish: 'Завърши',
    formButtonPrimary__remove: 'Remove',
    formButtonPrimary__save: 'Save',
    formButtonReset: 'Откажи',
    mfaPage: {
      formHint: 'Изберете метод, който да добавите.',
      title: 'Добави двустепенна верификация',
    },
    mfaPhoneCodePage: {
      backButton: 'Use existing number',
      primaryButton__addPhoneNumber: 'Добави телефонен номер',
      removeResource: {
        messageLine1: '{{identifier}} няма да получава повече кодове за потвърждение при влизане.',
        messageLine2: 'Вашият акаунт може да не е толкова сигурен. Сигурни ли сте, че искате да продължите?',
        successMessage: 'Двустепенното удостоверяване с SMS код беше премахнато за {{mfaPhoneCode}}',
        title: 'Премахване на двустепенното удостоверяване',
      },
      subtitle__availablePhoneNumbers:
        'Изберете телефонен номер, за да се регистрирате за двустепенното удостоверяване с SMS код.',
      subtitle__unavailablePhoneNumbers:
        'Няма налични телефонни номера за регистрация за двустепенното удостоверяване с SMS код.',
      successMessage1:
        'When signing in, you will need to enter a verification code sent to this phone number as an additional step.',
      successMessage2:
        'Save these backup codes and store them somewhere safe. If you lose access to your authentication device, you can use backup codes to sign in.',
      successTitle: 'SMS code verification enabled',
      title: 'Добавяне на SMS код за потвърждение',
    },
    mfaTOTPPage: {
      authenticatorApp: {
        buttonAbleToScan__nonPrimary: 'Сканирай QR кода вместо това',
        buttonUnableToScan__nonPrimary: 'Не може да се сканира QR кода?',
        infoText__ableToScan:
          'Настройте нов метод за влизане във вашия удостоверителен апликатор и сканирайте следващия QR код, за да го свържете с вашия акаунт.',
        infoText__unableToScan:
          'Настройте нов метод за влизане във вашия удостоверител и въведете предоставения по-долу ключ.',
        inputLabel__unableToScan1:
          'Уверете се, че времевите или еднократните пароли са активирани, след което завършете свързването на вашия акаунт.',
        inputLabel__unableToScan2:
          'Алтернативно, ако вашият удостоверител поддържа TOTP URI, можете също да копирате пълния URI.',
      },
      removeResource: {
        messageLine1: 'Кодовете за потвърждение от този удостоверител вече няма да са необходими при влизане.',
        messageLine2: 'Вашият акаунт може да не е толкова сигурен. Сигурни ли сте, че искате да продължите?',
        successMessage: 'Двустепенното удостоверяване чрез приложение за удостоверяване беше премахнато.',
        title: 'Премахване на двустепенното удостоверяване',
      },
      successMessage:
        'Двустепенното удостоверяване е активирано. При влизане, ще трябва да въведете код за потвърждение от това удостоверително приложение като допълнителна стъпка.',
      title: 'Добавяне на приложение за удостоверяване',
      verifySubtitle: 'Въведете код за потвърждение, генериран от вашето удостоверително приложение',
      verifyTitle: 'Код за потвърждение',
    },
    mobileButton__menu: 'Меню',
    navbar: {
      account: 'Profile',
      apiKeys: undefined,
      billing: undefined,
      description: 'Управлявайте информацията в профила си.',
      security: 'Security',
      title: 'Профил',
    },
    passkeyScreen: {
      removeResource: {
        messageLine1: undefined,
        title: undefined,
      },
      subtitle__rename: undefined,
      title__rename: undefined,
    },
    passwordPage: {
      checkboxInfoText__signOutOfOtherSessions:
        'It is recommended to sign out of all other devices which may have used your old password.',
      readonly:
        'Вашата парола в момента не може да бъде редактирана, тъй като можете да влизате само чрез корпоративна връзка.',
      successMessage__set: 'Паролата ви беше зададена.',
      successMessage__signOutOfOtherSessions: 'Всички други устройства бяха излезли.',
      successMessage__update: 'Паролата ви беше обновена.',
      title__set: 'Задай парола',
      title__update: 'Промени паролата',
    },
    phoneNumberPage: {
      infoText: 'Съобщение, съдържащо линк за потвърждение, ще бъде изпратено на този телефонен номер.',
      removeResource: {
        messageLine1: '{{identifier}} ще бъде премахнат от този профил.',
        messageLine2: 'Няма да можете да влезете в профила си, използвайки този телефонен номер.',
        successMessage: '{{phoneNumber}} беше премахнат от вашия профил.',
        title: 'Премахни телефонен номер',
      },
      successMessage: '{{identifier}} беше добавен към вашия профил.',
      title: 'Добави телефонен номер',
      verifySubtitle: 'Enter the verification code sent to {{identifier}}',
      verifyTitle: 'Verify phone number',
    },
    plansPage: {
      title: undefined,
    },
    profilePage: {
      fileDropAreaHint: 'Препоръчителен размер 1:1, до 10MB.',
      imageFormDestructiveActionSubtitle: 'Премахни',
      imageFormSubtitle: 'Качи',
      imageFormTitle: 'Профилна снимка',
      readonly: 'Информацията ви за профила е предоставена от корпоративната връзка и не може да бъде редактирана.',
      successMessage: 'Вашият профил е актуализиран.',
      title: 'Актуализиране на профила',
    },
    start: {
      activeDevicesSection: {
        destructiveAction: 'Излез от устройството',
        title: 'Активни устройства',
      },
      connectedAccountsSection: {
        actionLabel__connectionFailed: 'Опитайте отново',
        actionLabel__reauthorize: 'Авторизирайте сега',
        destructiveActionTitle: 'Премахни',
        primaryButton: 'Свържи акаунт',
        subtitle__disconnected: undefined,
        subtitle__reauthorize:
          'The required scopes have been updated, and you may be experiencing limited functionality. Please re-authorize this application to avoid any issues',
        title: 'Свързани акаунти',
      },
      dangerSection: {
        deleteAccountButton: 'Изтрий профила',
        title: 'Прекратяване на профила',
      },
      emailAddressesSection: {
        destructiveAction: 'Премахни имейл',
        detailsAction__nonPrimary: 'Задайте като основен',
        detailsAction__primary: 'Завърши потвърждение',
        detailsAction__unverified: 'Потвърдете',
        primaryButton: 'Добави имейл адрес',
        title: 'Имейл адреси',
      },
      enterpriseAccountsSection: {
        title: 'Корпоративни акаунти',
      },
      headerTitle__account: 'Профил',
      headerTitle__security: 'Сигурност',
      mfaSection: {
        backupCodes: {
          actionLabel__regenerate: 'Прегенерирай',
          headerTitle: 'Резервни кодове',
          subtitle__regenerate:
            'Вземете нов набор от сигурни резервни кодове. Предходните резервни кодове ще бъдат изтрити и не могат да бъдат използвани.',
          title__regenerate: 'Прегенерирай резервни кодове',
        },
        phoneCode: {
          actionLabel__setDefault: 'Задай като стандартен',
          destructiveActionLabel: 'Премахни',
        },
        primaryButton: 'Добави двустепенна верификация',
        title: 'Двустепенна верификация',
        totp: {
          destructiveActionTitle: 'Премахни',
          headerTitle: 'Приложение за удостоверяване',
        },
      },
      passkeysSection: {
        menuAction__destructive: undefined,
        menuAction__rename: undefined,
        primaryButton: undefined,
        title: undefined,
      },
      passwordSection: {
        primaryButton__setPassword: 'Задай парола',
        primaryButton__updatePassword: 'Промени паролата',
        title: 'Парола',
      },
      phoneNumbersSection: {
        destructiveAction: 'Премахни телефонен номер',
        detailsAction__nonPrimary: 'Задайте като основен',
        detailsAction__primary: 'Завърши потвърждение',
        detailsAction__unverified: 'Потвърдете телефонния номер',
        primaryButton: 'Добави телефонен номер',
        title: 'Телефонни номера',
      },
      profileSection: {
        primaryButton: 'Редактирайте профила',
        title: 'Профил',
      },
      usernameSection: {
        primaryButton__setUsername: 'Задай потребителско име',
        primaryButton__updateUsername: 'Промени потребителското име',
        title: 'Потребителско име',
      },
      web3WalletsSection: {
        destructiveAction: 'Премахни портфейл',
        detailsAction__nonPrimary: undefined,
        primaryButton: 'Web3 портфейли',
        title: 'Web3 портфейли',
      },
    },
    usernamePage: {
      successMessage: 'Вашето потребителско име е актуализирано.',
      title__set: 'Актуализиране на потребителското име',
      title__update: 'Актуализиране на потребителското име',
    },
    web3WalletPage: {
      removeResource: {
        messageLine1: '{{identifier}} ще бъде премахнат от този профил.',
        messageLine2: 'Няма да можете да влезете в профила си, използвайки този web3 портфейл.',
        successMessage: '{{web3Wallet}} беше премахнат от вашия профил.',
        title: 'Премахни web3 портфейл',
      },
      subtitle__availableWallets: 'Изберете web3 портфейл, за да го свържете с вашия профил.',
      subtitle__unavailableWallets: 'Няма налични web3 портфейли.',
      successMessage: 'Портфейлът беше добавен към вашия профил.',
      title: 'Добави web3 портфейл',
      web3WalletButtonsBlockButton: undefined,
    },
  },
  waitlist: {
    start: {
      actionLink: 'Sign up',
      actionText: "Don't have an account?",
      formButton: 'Join waitlist',
      subtitle: "Join our waitlist and we'll notify you once we are ready.",
      title: 'Join our waitlist',
    },
    success: {
      message: 'You have successfully joined the waitlist. We will notify you when access is available.',
      subtitle: 'Thank you for your patience.',
      title: 'Waitlist successful',
    },
  },
} as const;
